import React from "react";
import styled from "styled-components";
import en from "../language/Eng_Script.json";

const BottomMenu = () => {
  const { bottommenu } = en;

  const getGoogleMapsLink = (address: string) => {
    return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;
  };

  return (
    <Wrapper>
      <ContentArea>
        <BranchSection>
          <BranchColumn>
            <Line><strong>{bottommenu.hornsby.name}</strong></Line>
            <Line>
              Address: 
              <a 
                href={getGoogleMapsLink(bottommenu.hornsby.location)} 
                target="_blank" 
                rel="noopener noreferrer"
              >
                {bottommenu.hornsby.location}
              </a>
            </Line>
            <Line>
              Phone: 
              <a href={`tel:${bottommenu.hornsby.number.replace(/\s+/g, '')}`}>
                {bottommenu.hornsby.number}
              </a>
            </Line>
          </BranchColumn>

          <BranchColumn>
            <Line><strong>{bottommenu.eastwood.name}</strong></Line>
            <Line>
              Address: 
              <a 
                href={getGoogleMapsLink(bottommenu.eastwood.location)} 
                target="_blank" 
                rel="noopener noreferrer"
              >
                {bottommenu.eastwood.location}
              </a>
            </Line>
            <Line>
              Phone: 
              <a href={`tel:${bottommenu.eastwood.number.replace(/\s+/g, '')}`}>
                {bottommenu.eastwood.number}
              </a>
            </Line>
          </BranchColumn>

          <BranchColumn>
            <Line><strong>Inquiries</strong></Line>
            <Line>{bottommenu.bookingInfo}</Line>
            <Line>Instagram Handle: 
              <a 
                href={`https://instagram.com/${bottommenu.instagram.replace(/^@/, "")}`} 
                target="_blank" 
                rel="noopener noreferrer"
              >
                {bottommenu.instagram}
              </a>
            </Line>
            <Line>
              {bottommenu.otherInquiries}
              <a href={`mailto:${bottommenu.email}`}>{bottommenu.email}</a>
            </Line>
          </BranchColumn>
        </BranchSection>

        <FooterNoteSection>
          <Line className="group-text">{bottommenu.group}</Line>
        </FooterNoteSection>
      </ContentArea>

      <LogoSection>
        <img src={process.env.PUBLIC_URL + "/assets/Logo_1.png"} alt="Logo" />
      </LogoSection>
    </Wrapper>
  );
};

export default BottomMenu;

const Wrapper = styled.footer`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 30px 60px;
  background-color: #96bac4;

  @media (max-width: 1200px) {
    flex-direction: column;
    padding: 20px 30px;
  }
`;

const ContentArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 25px;
  flex: 1;
`;

const BranchSection = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px 80px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 20px;
  }
`;

const BranchColumn = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 350px;
`;

const FooterNoteSection = styled.div`
  border-top: 1px solid rgba(250, 242, 192, 0.3);
  padding-top: 10px;
`;

const Line = styled.p`
  margin: 3px 0;
  font-size: 14px;
  color: #faf2c0;
  line-height: 1.5;

  strong {
    color: #faf2c0;
    font-weight: 800;
    font-size: 16px;
    display: block;
    margin-bottom: 4px;
  }

  a {
    color: #faf2c0;
    text-decoration: none;
    margin-left: 4px;
    
    &:hover {
      text-decoration: underline;
    }
  }

  &.group-text {
    font-size: 12px;
    opacity: 0.8;
  }
`;

const LogoSection = styled.div`
  img {
    width: 140px;
    height: auto;
  }

  @media (max-width: 1200px) {
    margin-top: 25px;
    align-self: flex-start;
  }
`;